import { Accordion, Box, Stack, Text } from "@origin-digital/ods-core";
import { formatLabel } from "@/utils";
import { Household } from "./Household";
import React from "react";
import { sharedContent as content } from "./content.json";
import { IIBatterySizePrice } from "@/contract/generated/electrify-v1";
import { BatteryDetails } from "./BatteryDetails";

export const BatteryAccordion = ({
  accordionId,
  defaultExpanded,
  batterySizePrice,
}: {
  accordionId: string;
  defaultExpanded: boolean;
  batterySizePrice: IIBatterySizePrice;
}) => {
  const { batterySize, howManyPersonalHouseholdSupported } = batterySizePrice;

  const shouldDisplayHouseholdSection =
    howManyPersonalHouseholdSupported! > 0 &&
    howManyPersonalHouseholdSupported! <= 5;

  return (
    <Accordion
      size={"small"}
      id={accordionId}
      defaultExpanded={defaultExpanded}
      key={accordionId}
      summary={
        <Stack space={"none"}>
          <Text variant={"subtitle-small"} tone={"neutralDark"}>
            <b>
              {formatLabel(
                content.battery.accordion.summaryHeading,
                (value) => (
                  <>{value}</>
                ),
                batterySize!
              )}
            </b>
          </Text>
          <Text tone={"neutralDark"} variant={"body-small"}>
            {formatLabel(
              content.battery.accordion.summarySubheading,
              (value) => (
                <>{value}</>
              ),
              batterySize!
            )}
          </Text>
        </Stack>
      }
    >
      <Box
        display="flex"
        marginBottom="xsmall"
        flexDirection={{ xs: "column", lg: "row" }}
      >
        <BatteryDetails batterySizePrice={batterySizePrice} />
        {shouldDisplayHouseholdSection && (
          <Household numberOfPeople={howManyPersonalHouseholdSupported!} />
        )}
      </Box>
    </Accordion>
  );
};
